import handlers from '~/resources/tracking'

export default defineNuxtRouteMiddleware(() => {
  if (!import.meta.client) return

  window.dataLayer = window.dataLayer || []
  useTracking().init(handlers, handlers.pageload.dataLayerPageLoad)
})
